import request from '../utils/requset'

export async function sendMessage<T>(data: any, url: string) {
  const response: T = await request.post(url, data)

  return response as T
}

export function healthy(url: string) {
  return request({
    url,
    method: 'get',
    params: null,
  })
}
